export default __webpack_public_path__ + "static/media/browsing_items_image.d4e6550c.png";